
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    // Libs
import { EngagementConfig } from '@/lib/analytics/pages/engagement';
// Components
import { LayoutAnalyticsTreeStructure } from '@/components/layouts/wrappers/LayoutAnalytics';
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
const Engagement = () => (<WrapperSwitchLayout>
        <LayoutAnalyticsTreeStructure profileConfig={EngagementConfig} title="commons:menu.engagement"/>
    </WrapperSwitchLayout>);
export default Engagement;

    async function __Next_Translate__getStaticProps__19a539cc986__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/analytics/engagement',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19a539cc986__ as getStaticProps }
  